<ion-tabs (ionTabsDidChange)="onTabSelect($event)">
    <ion-tab-bar slot="bottom">
        <ion-tab-button
            *ngFor="let tab of tabsArray"
            [tab]="tab.tabName"
            [disabled]="tab.disabled"
            [routerLink]="tab.href"
            [ngClass]="{ 'tab-button-highlighted': tab.highlightButton }">
            <lib-svg-icon [size]="24" [iconName]="tab.iconDefault" />
            <ion-label class="sr-only">{{ tab.name }}</ion-label>
        </ion-tab-button>
    </ion-tab-bar>
</ion-tabs>
